var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0439 0.187988C9.02394 0.187988 0.0439453 9.16799 0.0439453 20.188C0.0439453 31.208 9.02394 40.188 20.0439 40.188C31.0639 40.188 40.0439 31.208 40.0439 20.188C40.0439 9.16799 31.0639 0.187988 20.0439 0.187988ZM29.6039 15.588L18.2639 26.928C17.9839 27.208 17.6039 27.368 17.2039 27.368C16.8039 27.368 16.4239 27.208 16.1439 26.928L10.4839 21.268C9.90394 20.688 9.90394 19.728 10.4839 19.148C11.0639 18.568 12.0239 18.568 12.6039 19.148L17.2039 23.748L27.4839 13.468C28.0639 12.888 29.0239 12.888 29.6039 13.468C30.1839 14.048 30.1839 14.988 29.6039 15.588Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.6f0a1d091561bd9270826746bf15ee3f.svg";
export { ForwardRef as ReactComponent };